import React from 'react';
import {useConfirmationDialog, ConfirmationDialog} from "./ConfirmationDialog";
import {useNotificationSnackbar, NotificationSnackbar} from "./NotificationSnackbar";

const FeedbackContext = React.createContext();

const FeedbackProvider = props => {
    const {errorParser, children} = props;
    const confirmationDialog = useConfirmationDialog();
    const notificationSnackbar = useNotificationSnackbar(errorParser);

    const context = {
        showErrorNotification: notificationSnackbar.showError,
        showSuccessNotification: notificationSnackbar.showSuccess,
        askConfirmation: confirmationDialog.askConfirmation,
    };

    return (
        <FeedbackContext.Provider value={context} {...props} >
            {children}
            {
                confirmationDialog.isOpen &&
                <ConfirmationDialog
                    options={confirmationDialog.options}
                    onClose={confirmationDialog.onClose}/>
            }

            {
                notificationSnackbar.notification &&
                <NotificationSnackbar
                    notification={notificationSnackbar.notification}
                    onClose={notificationSnackbar.handleClose}/>
            }
        </FeedbackContext.Provider>
    )
};

const useFeedbackTools = () => {
    return React.useContext(FeedbackContext);
};

export {FeedbackProvider, useFeedbackTools}